const FEATURED_DOMAIN = 'featured'
const FEATURED_STATE = {}

/**
 * The number of items feature per section.
 * @type {number}
 */
const FEATURED_ITEMS_PER_SECTION_COUNT = 3
export {
  FEATURED_DOMAIN,
  FEATURED_STATE,
  FEATURED_ITEMS_PER_SECTION_COUNT
}
